// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
// PCP Components
import { makeStyles } from '@mui/styles';
// Locales
import translate from 'locales/i18n';

const useStyles = makeStyles(() => ({
    borderedContainerRow: {
        margin: '10px',
        display: 'flex',
        justifyContent: 'center',
        fontSize: '1.1em'
    },
    borderedContainer: {
        display: 'flex',
        flexDirection: 'column',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderRadius: '4px',
        borderColor: 'rgba(0, 0, 0, 0.23)',
        width: '50%',
        overflowY: 'auto',
        overflowX: 'hidden'
    },
    formContent: {
        display: 'flex',
        justifyContent: 'center',
    },
    leftText: {
        marginRight: '10%',
        textAlign: 'right',
        width: '40%',
        overflowX: 'hidden'
    },
    rightText: {
        cursor: 'pointer',
        marginLeft: '10%',
        width: '40%',
        overflowX: 'hidden'
    }
}));

const ResumeImportSheet = ({ matchings, showDialogList }) => {
    const classes = useStyles();

    const getTranslation = (matching) => {
        if (matching[1].siteName) {
            return matching[1].siteName;
        }
        return matching[0];
    };

    return (
        <div className={classes.formContent}>
            <div className={classes.borderedContainer}>
                <div className={classes.borderedContainerRow} style={{ fontSize: '1.2em', color: 'rgba(0, 0, 0, 0.54)' }}>
                    <div className={classes.leftText}>{translate.i18n('ATTRIBUTE')}</div>
                    <div className={classes.rightText}>{translate.i18n('HEADER')}</div>
                </div>
                {matchings.map((matching, key) =>
                    <div className={classes.borderedContainerRow} onClick={() => showDialogList(matching[1].parsedData, 'Resumé de l\'entête ' + matching[1].header + ' associer à l\'attribut ' + getTranslation(matching))} key={key}>
                        <div className={classes.leftText}>{getTranslation(matching)}</div>
                        <div className={classes.rightText}>{matching[1].header}</div>
                    </div>
                )}
            </div>
        </div>
    );
};

ResumeImportSheet.propTypes = {
    matchings: PropTypes.array,
    showDialogList: PropTypes.bool
};

export default ResumeImportSheet;
